/**
 * The assets a page's layers still point at: an image layer's picture, an image fill or
 * stroke, and every alternative a generated fill keeps. A picture stays in the file's
 * asset list after its layer is deleted (undo needs it back), so "In this file" asks
 * this rather than listing every asset the file has ever held.
 */
export function usedAssetIds(nodes: Iterable<unknown>): Set<string> {
  const used = new Set<string>();
  const scan = (value: unknown, key?: string): void => {
    if (typeof value === 'string') {
      if (key === 'assetId') used.add(value);
      return;
    }
    if (Array.isArray(value)) {
      for (const item of value) {
        if (key === 'assetIds' && typeof item === 'string') used.add(item);
        else scan(item);
      }
      return;
    }
    if (value && typeof value === 'object') for (const [k, v] of Object.entries(value)) scan(v, k);
  };
  for (const node of nodes) scan(node);
  return used;
}
